/* ============================================================
   LIMINALIST — Shopify Theme JS v3 (Cursor removed)
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── SCANLINES ── */
  const scanlines = document.createElement('div');
  scanlines.className = 'lim-scanlines';
  document.body.appendChild(scanlines);

  /* ── MARQUEE ── */
  // Base set of items — will be duplicated 4x for seamless loop
  const baseItems = [
    'Automotive', 'Limited Edition', 'Cinematic', 'Print',
    'Dark', 'Editorial', 'Liminalist', 'Art Prints'
  ];

  // Duplicate 4 times so there's always enough content to fill the viewport
  const marqueeItems = [...baseItems, ...baseItems, ...baseItems, ...baseItems];

  const marqueeWrap = document.createElement('div');
  marqueeWrap.className = 'lim-marquee-wrap';

  // Create the track — the CSS animates it to -50%,
  // at which point it seamlessly aligns with the start again
  const buildTrack = () => {
    const track = document.createElement('div');
    track.className = 'lim-marquee-track';
    marqueeItems.forEach((item, i) => {
      const span = document.createElement('span');
      span.className = 'lim-marquee-item';
      span.textContent = item;
      track.appendChild(span);
      const dot = document.createElement('span');
      dot.className = 'lim-marquee-dot';
      dot.textContent = '\u00b7';
      track.appendChild(dot);
    });
    return track;
  };

  // Single track with enough items — CSS handles the loop via translateX(-50%)
  marqueeWrap.appendChild(buildTrack());

  const header = document.querySelector('header, .site-header, #shopify-section-header');
  if (header && header.nextSibling) {
    header.parentNode.insertBefore(marqueeWrap, header.nextSibling);
  } else {
    document.body.prepend(marqueeWrap);
  }

  /* ── GLITCH DIVIDER ── */
  const glitchItems = 'Liminalist   \u2022   Automotive Art   \u2022   Limited Edition Prints   \u2022   Austin, TX   \u2022   ';
  // Repeat enough times to fill any screen width
  const glitchFull = glitchItems.repeat(6);

  const glitchDiv = document.createElement('div');
  glitchDiv.className = 'lim-glitch-divider';
  const glitchSpan = document.createElement('span');
  glitchSpan.className = 'lim-glitch-text';
  glitchSpan.textContent = glitchFull + glitchFull; // doubled for seamless loop
  glitchDiv.appendChild(glitchSpan);

  const footer = document.querySelector('footer, .site-footer, #shopify-section-footer');
  if (footer) {
    footer.parentNode.insertBefore(glitchDiv, footer);
  }

  /* ── SCROLL REVEAL ── */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('lim-visible');
    });
  }, { threshold: 0.08 });

  document.querySelectorAll(
    '.product-card, .resource-card, .card-wrapper, .collection__title, .section__heading'
  ).forEach(el => {
    el.classList.add('lim-reveal');
    observer.observe(el);
  });

  /* ── BODY TOP PADDING (fixed header) ── */
  const headerEl = document.querySelector('header, .site-header');
  if (headerEl) {
    document.body.style.paddingTop = headerEl.offsetHeight + 'px';
  }

});